import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { TopServiceModel } from './model';
import { adapter, TopServiceState } from './state';

export const stateName: string = 'TopService';
export const selectEntityState: MemoizedSelector<object, TopServiceState> = createFeatureSelector<TopServiceState>(stateName);

export const getError = (state: TopServiceState): any => state.error;
export const getIsLoading = (state: TopServiceState): boolean => state.isLoading;

export const errorSelector: MemoizedSelector<object, any> = createSelector(selectEntityState, getError);
export const isLoadingSelector: MemoizedSelector<object, boolean> = createSelector(selectEntityState, getIsLoading);

export const allSelector: (state: object) => TopServiceModel[] = adapter.getSelectors(selectEntityState).selectAll;

export const byIdSelector = (id: number) =>
  createSelector(allSelector, (entities: TopServiceModel[]) => {
    return entities ? entities.find(e => e.id == id) : null;
  });
